import { HardDrive } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, StatusBadge, DataTable, DemoBadge, AsyncBoundary, RowsSkeleton, UsageBar } from "@/components/common";

export default function Volumes() {
  const { data, loading, error } = useAsync(() => api.getVolumes(), [], 20000);
  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={HardDrive} title="Volumes" description="Volumes persistentes de dados por servidor."
        breadcrumb={<><span>Infraestrutura</span><span>/</span><span className="text-foreground">Volumes</span></>}
        actions={<DemoBadge className="hidden sm:inline-flex" />} />
      <AsyncBoundary loading={loading} error={error} skeleton={<RowsSkeleton />}>
        <DataTable
          columns={[
            { key: "name", header: "Volume", render: (r) => <span className="font-medium text-foreground">{r.name}</span> },
            { key: "server", header: "Servidor", render: (r) => <span className="font-mono text-xs">{r.server}</span> },
            { key: "driver", header: "Driver" },
            { key: "size", header: "Tamanho", align: "right" },
            { key: "used", header: "Utilização", tdClassName: "w-48", render: (r) => <UsageBar pct={r.used} showValue /> },
            { key: "status", header: "Status", render: (r) => <StatusBadge status={r.status} size="sm" /> },
          ]}
          rows={data} keyField="name" testid="volumes-table" />
      </AsyncBoundary>
    </div>
  );
}
